import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = ({ className = '' }) => {
  const { currentLanguage, changeLanguage, getCurrentLanguageInfo, getAvailableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = getCurrentLanguageInfo();
  const availableLanguages = getAvailableLanguages();

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 rounded-full bg-stone-50 dark:bg-stone-800 border border-stone-100 dark:border-stone-700 hover:bg-stone-100 dark:hover:bg-stone-700 transition-all duration-300"
      >
        <span className="text-sm">{currentLang.flag}</span>
        <span className="text-[10px] font-black uppercase tracking-widest text-stone-600 dark:text-stone-300">{currentLang.name}</span>
        <i className={`fas fa-chevron-down text-[8px] text-stone-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          ></div>

          {/* Dropdown */}
          <div className="absolute top-full left-0 mt-3 w-full min-w-[10rem] bg-white/95 dark:bg-stone-900/95 backdrop-blur-xl border border-stone-100 dark:border-stone-800 rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.12)] z-20 overflow-hidden py-2">
            {availableLanguages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-left text-xs font-medium hover:bg-stone-50 dark:hover:bg-stone-800 transition-colors duration-200 ${
                  currentLanguage === lang.code ? 'text-amber-600 font-bold' : 'text-stone-600 dark:text-stone-300'
                }`}
              >
                <span className="text-sm">{lang.flag}</span>
                <span>{lang.name}</span>
                {currentLanguage === lang.code && (
                  <i className="fas fa-check text-amber-500 ml-auto"></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
